module.exports = __webpack_public_path__ + "media/theme/icon__time-02f5870b.svg";